import React, {CSSProperties, useState} from "react";

import AgentSubmission from "../../components/project/Agent.submission/Agent.submission";
import {IAgentQuery} from "../../api/Base/Base.types";
import AgentSignupApi from "../../api/AgentSignup/AgentSignup.api";
import {
    Alert, Button,
    Code,
    Group,
    LoadingOverlay,
    Paper,
    PasswordInput,
    Stack,
    Text,
    TextInput,
    useMantineTheme
} from "@mantine/core";
import {AlertCircle, Check} from "tabler-icons-react";
import {useModals} from "@mantine/modals";
import {Link, useNavigate} from "react-router-dom";

function AgentSubmissionForm() {
    const theme = useMantineTheme();
    const navigate = useNavigate();
    const [submittingForm, setSubmittingForm] = useState(false);
    const modals = useModals();

    async function onSubmitQuery(values: IAgentQuery) {
        let res = await AgentSignupApi.postData({queryKey: ["postAgentData", values]});
        setSubmittingForm(true);
        let commonModalProps = {
            centered: true,
            withCloseButton:false,
            closeOnClickOutside:false,
            closeOnEscape:false,
        }
        if (res === true) {
            let id = modals.openModal({
                ...commonModalProps,
                title: (
                    <Group spacing="xs">
                        <Check color="#51cf66"/>
                        <Text>Agent Form Submitted</Text>
                    </Group>
                ),
                children: (
                    <Stack>
                        <Text size="sm">
                            You have successfully sent your Agent information to AGL. To access and/or update your
                            submission, enter your email and form password:
                        </Text>
                        <TextInput label="Email" readOnly value={values.email}/>
                        <PasswordInput mb={12} label="Password" readOnly value={values.formPassword}/>
                        <Alert icon={<AlertCircle size={16}/>} color="blue">
                            Make sure to store your email and password, as you will <i>not</i> be able to change or
                            reset
                            your password. If you have forgotten your password, please contact AGL support to remedy the
                            issue.
                        </Alert>
                        <Button mt={12} color="blue" onClick={() => {
                            modals.closeModal(id)
                            navigate("/agent/update")
                        }}>
                            I have saved my credentials
                        </Button>
                    </Stack>
                ),
            })
            setSubmittingForm(false);
            return true;
        } else if (!res || res.errors) {
            modals.openModal({
                ...commonModalProps,
                title: (
                    <Group spacing="xs">
                        <AlertCircle color="#ff6b6b"/>
                        <Text>Error submitting Agent form</Text>
                    </Group>
                ),
                children: (
                    <Stack>
                        <Text size="sm" align="left">
                            Your form <i>could not</i> be submitted due to: <br/>
                            <Text size="sm" color="red">
                                {res.errors.title || res.errors || "No Error Specified"}
                            </Text>
                        </Text>
                        <Text size="sm">
                            If you have gotten this error multiple times please contact support and provide them
                            with this error
                            ID: <br/><Code>{res.errors.traceId || "Agent-Create-No-Error-Code-Specified"}</Code>.
                        </Text>
                    </Stack>

                ),
            })
            setSubmittingForm(false);
            return false;
        }
    }

    const commonPaperStyle: CSSProperties = {
        position: 'relative',
        width: "100%",
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        maxWidth: 750,
    }

    return (
        <Paper p="lg" shadow="sm" style={{...commonPaperStyle}}>
            <LoadingOverlay visible={submittingForm}/>
            <AgentSubmission onSubmitQuery={onSubmitQuery}/>
        </Paper>

    );
}

export default AgentSubmissionForm;